import React from 'react'
import { CushionChargePoliciesProvider } from './context/CushionChargePoliciesProvider'
import { CushionChargePoliciesWorkflowsProvider } from './context/CushionChargePoliciesWorkflowsProvider'
import { CushionChargePoliciesMain } from './components/CushionChargePoliciesMain'
import { CreateCushionChargePolicyFlow } from './workflows/CreateCushionChargePolicyFlow/CreateCushionChargePolicyFlow'
import { EditCushionChargePolicyFlow } from './workflows/EditCushionChargePolicyFlow/EditCushionChargePolicyFlow'

export const CushionChargePolicies = () => {
  return (
    <CushionChargePoliciesProvider>
      <CushionChargePoliciesWorkflowsProvider>
        <CushionChargePoliciesMain />
        <CreateCushionChargePolicyFlow />
        <EditCushionChargePolicyFlow />
      </CushionChargePoliciesWorkflowsProvider>
    </CushionChargePoliciesProvider>
  )
}
